import styled, { keyframes } from 'styled-components';

export const Container = styled.div`
  display: flex;
  width: 100%;
`;

export const ContainerListaPaciente = styled.div`
  width: 50%;
  padding: 20px;
  box-sizing: border-box;
  background-color: #f0f0f0;
  border-right: 1px solid #ccc;
`;

export const ContainerUltimoPaciente = styled.div`
  width: 50%;
  padding: 20px;
  box-sizing: border-box;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  font-weight: bold;
`;

export const ListPacienteUl = styled.ul`
  list-style-type: none;
  padding: 0;
`;

export const ListPacienteItem = styled.li`
  padding: 10px;
  border-bottom: 1px solid #ccc;
`;

export const ContainerGrid = styled.div`
  display: grid;

  /* grid-template-rows: 1fr 1fr 1fr 1fr; */
  grid-template-columns: 1fr 1fr 1fr;

  gap: 0.5rem;
  height: 100vh;
`;

export const Header = styled.div`
  color: #fff;
  grid-row-start: 1;
  grid-column-start: 1;

  grid-row-end: 2;
  grid-column-end: 4;
  height: 70px;
`;

export const ContainerImagem = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  color: #fff;
  background-color: #006f7f;
  padding: 1rem 1.5rem;
  font-size: 2rem;
  font-weight: bold;
  img {
    width: auto;
    height: 50px;
  }
`;

export const Footer = styled.div`
  height: 70px;
  background-color: #34495e;
  color: #fff;
  grid-row-start: 4;
  grid-column-start: 1;

  grid-row-end: 5;
  grid-column-end: 4;
  align-self: end;
`;

export const Rooler = styled.div`
  height: 70px;
  line-height: 65px;
  position: relative;
  overflow: hidden;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.6rem;
  color: #fff;
`;

const slide = keyframes`
  0% {
    top: 0;
  }

  25% {
    top: -4rem;
  }

  50% {
    top: -8rem;
  }

  72.5% {
    top: -12.25rem;
  }
`;
export const RoolerText = styled.span`
  position: absolute;
  top: 0;
  animation: ${slide} 30s infinite ease-in-out;
`;

export const Painel = styled.div`
  height: calc(100vh - 170px);
  min-height: 250px;
  padding: 0.5rem 0.5rem 0.5rem 1rem;

  grid-row-start: 2;
  grid-column-start: 1;

  grid-row-end: 4;
  grid-column-end: 3;
`;

export const Box = styled.div`
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
`;

const scaleUp = keyframes`
  from {
    background-color: #FF0;
  }

  to {
    background-color: #AD310B;
        color:#fff;
  }
`;

export const BoxPainel = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  justify-content: center;
  align-items: center;
  padding: 1rem;
  @media (max-width: 800px) {
    padding: 0.5rem;
  }

  height: 100%;
  color: #000;
  & :nth-child(1) {
    width: 100%;
    font-size: 5rem;
    font-weight: bold;
    text-align: center;
    text-transform: uppercase;
    color: #006f7f;
    padding: 1rem 0;
    margin-bottom: 0;
    animation: ${scaleUp} 0.5s 8 alternate ease-in-out;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    @media (max-width: 800px) {
      font-size: 3.5rem;
      padding: 0.5rem 0;
    }
  }
  & :nth-child(2) {
    font-size: 3.5rem;
    font-weight: bold;
    text-align: center;
    @media (max-width: 800px) {
      font-size: 2rem;
    }
  }
`;

export const Lateral = styled.div`
  height: calc(100svh - 170px);
  padding: 0.5rem 1rem 0.5rem 0.5rem;

  grid-row-start: 2;
  grid-column-start: 3;

  grid-row-end: 4;
  grid-column-end: 4;
`;

export const BoxLateral = styled(Box)`
  padding: 1rem;
  @media (max-width: 800px) {
    padding: 0.6rem;
  }
  height: 100%;
  overflow: hidden;
  p {
    font-size: 1.3rem;
    font-weight: bold;
    @media (max-width: 800px) {
      font-size: 0.7rem;
    }
  }
  table {
    font-size: 0.9rem;
    @media (max-width: 800px) {
      font-size: 0.5rem;
    }
    width: 100%;
  }

  table,
  th,
  td {
    border: 0;
  }

  th {
    text-align: left;
    font-size: 1rem;
    @media (max-width: 800px) {
      font-size: 0.5rem;
    }
  }

  td {
    padding: 0.5rem;
    @media (max-width: 800px) {
      font-size: 0.3rem;
    }
  }

  tr:nth-child(even) {
    background-color: #f2f2f2;
  }
`;
